'use client';

import { useEffect, useState } from 'react';
import { getPagedItemsLegacy } from './pagination-legacy.service';

export function usePaginationLegacy<T>($items: T[], $page: number = 1, $perPage: number = 15) {

  const total = $items.length;

  const [page, setPage] = useState($page);
  const [perPage, setPerPage_] = useState($perPage);
  const [items, setItems] = useState(getPagedItemsLegacy<T>($items, $page, $perPage));

  const pages = Math.ceil(total / perPage);

  useEffect(() => {
    // console.log('setPaginationLegacy');
    setItems(getPagedItemsLegacy<T>($items, page, perPage));
  }, [$items]);

  function goToPage(page: number) {
    if (page > 0 && page <= pages) {
      // console.log('goToPage', page);
      setPage(page);
      setItems(getPagedItemsLegacy<T>($items, page, perPage));
    }
  }

  function setPerPage(perPage: number) {
    if (perPage > 0) {
      // console.log('setPerPage', perPage);
      const pages = Math.ceil(total / perPage);
      const newPage = Math.max(1, Math.min(pages, page));
      setPage(newPage);
      setPerPage_(perPage);
      setItems(getPagedItemsLegacy<T>($items, newPage, perPage));
    }
  }

  function nextPage() {
    goToPage(page + 1);
  }

  function previousPage() {
    goToPage(page - 1);
  }

  return { items, page, pages, total, nextPage, previousPage, goToPage, setPerPage };
}
